import React, { FC, useContext } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { SearchCommentariesModal } from '../commentaries-modal/SearchCommentariesModal';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContext } from '../../../../user/UserContext';
import { GetCommentaryResponse } from '../commentaries-modal/decisionApi';
import { createRandomKey } from '../../../../utils/jsxUtils';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { useModal } from '../../../../components/modal/useModal';
import { EntityCommentary } from '../../../search.types';
import { getCommentariesLabel } from './getCommentariesLabel';

type Props = {
  docId: string;
  searchType: string;
  commentaries: Array<EntityCommentary>;
  numberOfComments: number;
  otherCommentAuthorsCount: number;
  nextCommentAuthors: string[];
  allCommentariesGetter: (
    docId: string,
    query: string,
  ) => Promise<{ data: Array<GetCommentaryResponse> }>;
};

export const HitCommentariesListSeeMore: FC<Props> = ({
  docId,
  allCommentariesGetter,
  searchType,
  numberOfComments,
  commentaries,
  nextCommentAuthors = [],
  otherCommentAuthorsCount,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  const { openModal } = useModal(modalProps => (
    <SearchCommentariesModal
      docId={docId}
      // @ts-ignore
      allCommentariesGetter={allCommentariesGetter}
      searchType={searchType}
      {...modalProps}
    />
  ));
  const onClick = () => {
    if (accessPremium) {
      doctrineAnalytics('Search ModalCommentsOpened', {
        source: 'excerpt',
        doc_id: docId,
        reportOriginalQueryKey: true,
        search_type: searchType,
      });
      openModal();
    } else {
      openRestrictedModal({ source: 'excerpt_comments' });
    }
  };

  const id = `hit-comment-${createRandomKey()}`;
  const extraCommentaries = numberOfComments - commentaries.length;
  const authorsLabel = getCommentariesLabel(
    nextCommentAuthors,
    otherCommentAuthorsCount,
  );

  return (
    <>
      <button
        type="button"
        className="see-more-commentaries"
        onClick={onClick}
        data-for={id}
        data-tip
        data-offset="{'top': -10}"
      >
        <FormattedMessage
          id="HitCommentariesListSeeMore/button"
          values={{ count: extraCommentaries }}
        />
      </button>

      <Tooltip effect="solid" place="top" id={id}>
        <div className="see-more-commentaries__popover">{authorsLabel}</div>
      </Tooltip>
    </>
  );
};
